import { useIntl } from 'react-intl'
import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'LuxKit/Typography/Caption'
import RadioInput from 'LuxKit/Radio/RadioInput'
import { Divider } from '../../Shared/Divider'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import BodyText from 'LuxKit/Typography/BodyText'
import Typography from 'LuxKit/Typography/Typography'

interface Props {
  bonusInclusions: boolean
  checked: boolean
  name: number
  nights: number
  onSwitchPackageDuration: () => void
  price: number
  hasMemberPrice: boolean
}

function BnblSwitchPackageDurationItem({ checked, name, nights, onSwitchPackageDuration, price, hasMemberPrice }: Props) {
  const intl = useIntl()
  return (
    <>
      <ClickableListItem
        title={intl.formatMessage(
          {
            id: 'AJCzzicy2XBeD3lW5BFC',
            defaultMessage: '{count, plural, one {# night} other {# nights}}',
            description: 'Duration option title for BNBL switch package duration',
          },
          { count: nights },
        )}
        onClick={onSwitchPackageDuration}
        startIcon={<RadioInput name={name.toString()} checked={checked} />}
      >
        <div>
          <Caption colour="light-foreground-alt" variant="medium">{intl.formatMessage({
            id: 'fJR7TLcbR6it6fEUwtkK',
            defaultMessage: 'From',
            description: 'Pricing label prefix before BNBL package duration price',
          })}
          </Caption>
          <Typography wrap="no-wrap" style={{ display: 'inline-flex', gap: '0.25em', alignItems: 'baseline' }}>
            <BodyText as="span" variant="large" colour={hasMemberPrice ? 'lux-plus' : undefined}>
              <FormatCurrency value={price} />
            </BodyText>
            <Caption as="span" colour="light-foreground-alt" variant="medium">
              {intl.formatMessage({
                id: 'MV7GsTtrrNnOjGZntkTn',
                defaultMessage: 'total',
                description: 'Pricing unit suffix indicating total price for BNBL package duration',
              })}
            </Caption>
          </Typography>
        </div>
      </ClickableListItem>
      <Divider />
    </>
  )
}

export default BnblSwitchPackageDurationItem
